{
  "error.unauthenticated": "You need to sign in to continue.",
  "error.forbidden": "You do not have access to this.",
  "error.not_found": "We could not find what you were looking for.",
  "error.rate_limited": "Too many attempts. Wait a moment and try again.",
  "error.token_invalid": "That link does not work. Request a new one from your confirmation email.",
  "error.token_expired": "That link has expired. Request a new one from your confirmation email.",
  "error.token_already_used": "That link has already been used.",
  "error.validation_failed": "Something in the form does not look right.",
  "error.internal": "Something went wrong on our side. Please try again shortly.",
  "error.slot_unavailable": "That time has just been taken. Pick another one below.",
  "error.hold_expired": "Your reservation expired. Pick the time again and we will hold it ten minutes.",
  "error.outside_booking_window": "That time cannot be booked. Choose a time further ahead.",
  "error.too_late_to_cancel": "It is too late to change this booking yourself. Call the workshop and we will sort it out.",
  "error.invalid_status_transition": "This booking cannot move to that status.",
  "error.service_unavailable": "That service is not offered at this location.",
  "error.no_resource_available": "Nobody is free for that job then. Pick another time.",
  "error.outside_service_area": "That address is outside the workshop's service area.",
  "error.daily_limit_reached": "The workshop is fully booked that day. Pick another day.",
  "error.idempotency_key_reused": "That request was replayed with different contents.",
  "error.storage_unavailable": "Photo upload is not switched on here. Contact support.",
  "error.integration_unavailable": "Google Calendar is not switched on here. Contact support.",
  "error.integration_handshake_failed": "The connection to Google was interrupted. Try connecting again.",
  "error.resource_in_use": "There are upcoming bookings left. Move them over first.",
  "error.product_unavailable": "One or more products cannot be ordered right now.",
  "error.workshop_paused": "This workshop is paused and cannot order right now.",
  "error.address_incomplete": "The delivery address is missing a street address or postcode.",
  "error.outside_working_hours": "The job does not fit in working hours from that start time.",
  "error.email_taken": "That email address is already used by another account.",
  "error.shared_account": "This person also works at another workshop. Contact HQ to change the account.",
  "error.owner_exists": "This workshop already has an active owner."
}
